import { getUsers } from "../services/api-server/user";

// The lower-cased emails in these fields of the items, once each, sorted.
function collectEmails(items: any[], fields: string[]): string[] {
	const emails = (Array.isArray(items) ? items : [])
		.flatMap((item: any) => fields.map((field) => item?.[field]))
		.filter((e: unknown): e is string => typeof e === "string" && e !== "")
		.map((e) => e.toLowerCase());
	return Array.from(new Set(emails)).sort((a, b) => a.localeCompare(b));
}

export function collectFindingsResponsibleEmails(records: any[]): string[] {
	return collectEmails(
		(Array.isArray(records) ? records : []).flatMap(
			(rec: any) => rec?.findings ?? []
		),
		["responsible"]
	);
}

// Everyone an item list names, for the names a page shows: who is
// responsible and, where recorded, who completed each item. The Responsible
// filter lists only the responsible people: collectResponsibleEmails.
export function collectPeopleEmails(items: any[]): string[] {
	return collectEmails(items, ["responsible", "completed_by"]);
}

export async function fetchEmailToNameMap(
	emails: string[]
): Promise<Record<string, string>> {
	if (!emails?.length) return {};
	const users = (await getUsers(emails)) as any[] | null;
	const emailToName: Record<string, string> = {};
	(users ?? []).forEach((u: any) => {
		if (u?.email) {
			emailToName[u.email.toLowerCase()] = u?.name ?? u?.email;
		}
	});
	return emailToName;
}

// The items' responsible people, for the Responsible filter. Names to show
// include whoever completed an item: collectPeopleEmails.
export function collectResponsibleEmails(items: any[]): string[] {
	const emails = (Array.isArray(items) ? items : [])
		.map((item: any) => item?.responsible)
		.filter(Boolean)
		.map((e: string) => e?.toLowerCase?.())
		.filter((email): email is string => !!email);
	return Array.from(new Set(emails)).sort((a, b) => a.localeCompare(b));
}

// Adds responsible_name to each item, and completed_by_name to those that
// record who completed them.
export function addResponsibleNames(
	items: any[],
	emailToName: Record<string, string>
): any[] {
	return (items ?? []).map((item: any) => ({
		...item,
		responsible_name:
			emailToName[item?.responsible?.toLowerCase?.()] ??
			item?.responsible ??
			"",
		...(typeof item?.completed_by === "string" &&
			item.completed_by && {
				completed_by_name:
					emailToName[item.completed_by.toLowerCase()] ?? item.completed_by,
			}),
	}));
}
